/**
 * @returns {React.ReactElement}
 */

const ContentHubQuotation = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 495 495"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="495" height="495" fill="#002967" />
    <g clipPath="url(#clip0_7761_3916)">
      <path
        d="M176.385 343.74L150.505 328.31C160.325 313.62 167.705 299.98 174.025 284.55C180.065 268.8 183.765 252.96 183.935 235.75L138.395 235.69L138.245 151.35L222.775 151.26L222.795 225.84C221.455 252.53 214.785 277.39 203.185 301.23C195.625 316.41 186.995 329.86 176.395 343.74H176.385Z"
        fill="white"
      />
      <path
        d="M309.635 344.17L282.655 328.07C302.995 300.8 314.665 270.21 318.555 235.39L270.795 235.02L270.835 150.83L356.755 150.85L356.695 219.37C356.395 234.62 354.025 248.48 350.225 263.27C342.025 292.55 328.145 318.88 309.635 344.16V344.17Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7761_3916">
        <rect
          width="495"
          height="193.34"
          fill="white"
          transform="translate(0 150.83)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ContentHubQuotation;
